import React, { useState, useEffect } from "react";

const CountdownTimer = (props) => {
  const { targetSeconds, onTimeLeftChange } = props;
  const [timeLeft, setTimeLeft] = useState(targetSeconds);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (timeLeft > 0) {
        setTimeLeft(timeLeft - 1);
        onTimeLeftChange(timeLeft); 
      } else {
        clearInterval(intervalId);
        onTimeLeftChange(0); 
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft,onTimeLeftChange]);


  const hour = Math.floor(timeLeft / 3600)
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((timeLeft % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (timeLeft % 60).toString().padStart(2, "0");

  return (
    <span>
      {hour}:{minutes}:{seconds}
    </span>
  );
};

export default CountdownTimer;
